<template>
  <div id="app-header">
    <img
      id="dj-logo"
      :src="
        showStyle === 0
          ? require(`@/assets/images/djxinxilogo.png`)
          : require(`@/assets/images/djxinxilogo1.png`)
      "
      @click="logoClick()"
    />

    <template v-for="(nav, index) in topMenus" :key="nav.id">
      <!-- 有子菜单的项 -->
      <el-popover
        v-if="nav.children && nav.children.length > 0"
        placement="bottom-start"
        effect="dark"
        :width="nav.children.length > 4 ? 460 : 220"
        trigger="hover"
        :show-arrow="false"
      >
        <template #reference>
          <router-link
            :to="nav.path"
            active-class="nav-active"
            :class="showStyle === 0 ? 'nav-common-style0' : 'nav-common-style1'"
            class="nav-common"
            :style="navPositions[index]"
          >
            {{ nav.name }}
          </router-link>
        </template>
        <div
          class="mega-menu-container"
          :class="{ 'two-columns': nav.children && nav.children.length > 4 }"
        >
          <router-link
            :to="sub.path"
            active-class="sub-active"
            v-for="sub in nav.children"
            :key="sub.id"
            class="nav-sub-item"
          >
            <span class="sub-item-text">{{ sub.name }}</span>
            <i class="arrow-icon"></i>
          </router-link>
        </div>
      </el-popover>

      <!-- 无子菜单的项 -->
      <router-link
        v-else
        :to="nav.path"
        active-class="nav-active"
        :class="showStyle === 0 ? 'nav-common-style0' : 'nav-common-style1'"
        class="nav-common"
        :style="navPositions[index]"
      >
        {{ nav.name }}
      </router-link>
    </template>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { publicApi } from "@/api/http";
import constants from "@/api/constants";

export default {
  name: "HeaderView",
  props: {
    showStyle: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const router = useRouter();
    const topMenus = ref([]);

    // 导航位置样式（保持原有布局）
    const navPositions = computed(() => {
      const positions = [
        "left:517px;width: 44px",
        "left:727px;width: 86px",
        "left:976px;width: 86px",
      ];
      return positions;
    });

    async function loadMenus() {
      try {
        // 1. 先加载菜单树获取顶级导航（首页、产品中心、新闻资讯）
        const menuRes = await publicApi.getMenus();
        let menus = [];
        if (menuRes.code === 0 && menuRes.data.length > 0) {
          menus = menuRes.data;
        } else {
          useFallbackData();
          return;
        }

        // 2. 加载产品列表，用于填充"产品中心"的子菜单
        let productChildren = [];
        try {
          const prodRes = await publicApi.getProducts();
          if (prodRes.code === 0 && prodRes.data.length > 0) {
            productChildren = prodRes.data.map((p) => ({
              id: `product_${p.id}`,
              name: p.name,
              path: `/product/${p.id}`,
            }));
          }
        } catch (e) {
          // 产品API不可用时产品中心无子菜单
        }

        // 3. 将产品填充到"产品中心"菜单项的children
        topMenus.value = menus.map((menu) => {
          if (menu.path === "/product") {
            return { ...menu, children: productChildren };
          }
          return menu;
        });
      } catch (e) {
        useFallbackData();
      }
    }

    function useFallbackData() {
      topMenus.value = constants.navData.map((nav, i) => ({
        id: i,
        name: nav.pageName,
        path: nav.path,
        children: [],
      }));
    }

    function logoClick() {
      const firstMenu = topMenus.value[0];
      router.push({ path: firstMenu ? firstMenu.path : "/main" });
    }

    onMounted(loadMenus);

    return { topMenus, navPositions, logoClick };
  },
};
</script>

<style scoped>
#app-header {
  width: 100%;
  height: 98px;
  position: relative;
}

#dj-logo {
  width: 180px;
  height: 55px;
  margin-left: 179px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.nav-common {
  font-size: 19px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.nav-common-style0 {
  color: white;
}

.nav-common-style1 {
  color: black;
}

.mega-menu-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 4px;
}
.two-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.nav-sub-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  text-decoration: none;
  color: #e5e7eb;
  font-size: 15px;
  border-radius: 4px;
  transition: all 0.3s ease;
  background: transparent;
  border: 1px solid transparent;
}
.nav-sub-item:hover {
  background: rgba(0, 242, 254, 0.08);
  border-color: rgba(0, 242, 254, 0.3);
  color: #00f2fe;
}
.sub-active {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(0, 160, 233, 0.8) 0%,
    rgba(0, 242, 254, 0.4) 100%
  );
  border-color: #00f2fe;
  font-weight: bold;
}
.sub-active .arrow-icon {
  opacity: 1;
}
.sub-item-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
.arrow-icon {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-left: 10px;
  border-top: 2px solid #00f2fe;
  border-right: 2px solid #00f2fe;
  transform: rotate(45deg);
  opacity: 0;
  transition: all 0.3s;
}
.nav-sub-item:hover .arrow-icon {
  opacity: 1;
  transform: translateX(4px) rotate(45deg);
}

.nav-active {
  color: #266db7;
}

/* =========== RESPONSIVE DESIGN (MOBILE ADAPTATION) =========== */
@media screen and (max-width: 768px) {
  #app-header {
    height: auto !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 10px 15px;
  }
  #dj-logo {
    position: relative !important;
    top: 0 !important;
    transform: none !important;
    margin-left: 0 !important;
    width: 150px !important;
    height: auto !important;
    display: block;
    margin-bottom: 10px;
    width: 100%;
  }
  .nav-common {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: auto !important;
    font-size: 16px !important;
    margin-right: 15px !important;
  }
}
</style>
